const API_BASE = (import.meta.env.VITE_MALL_API_BASE_URL || 'http://localhost:8087').replace(/\/+$/, '')

async function request(path, options = {}) {
  const { params, ...fetchOptions } = options
  const query = params
    ? `?${new URLSearchParams(Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')).toString()}`
    : ''
  const token = localStorage.getItem('mallAccessToken')
  const isFormData = typeof FormData !== 'undefined' && fetchOptions.body instanceof FormData
  const headers = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  }
  if (isFormData) {
    delete headers['Content-Type']
  }
  const response = await fetch(`${API_BASE}${path}${query}`, {
    headers,
    ...fetchOptions,
  })
  const data = await response.json()
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem('mallAccessToken')
      localStorage.removeItem('mallRefreshToken')
      localStorage.removeItem('mallUser')
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
        const redirect = `${window.location.pathname}${window.location.search}`
        window.location.href = `/login?redirect=${encodeURIComponent(redirect)}`
      }
    }
    const error = new Error(data?.message || 'API request failed')
    error.response = { status: response.status, data }
    throw error
  }
  return { data }
}

export default {
  get(path, options = {}) {
    return request(path, options)
  },
  post(path, body, options = {}) {
    const isFormData = typeof FormData !== 'undefined' && body instanceof FormData
    return request(path, { ...options, method: 'POST', body: isFormData ? body : JSON.stringify(body || {}) })
  },
  put(path, body, options = {}) {
    const isFormData = typeof FormData !== 'undefined' && body instanceof FormData
    return request(path, { ...options, method: 'PUT', body: isFormData ? body : JSON.stringify(body || {}) })
  },
  patch(path, body, options = {}) {
    const isFormData = typeof FormData !== 'undefined' && body instanceof FormData
    return request(path, { ...options, method: 'PATCH', body: isFormData ? body : JSON.stringify(body || {}) })
  },
  delete(path, options = {}) {
    return request(path, { ...options, method: 'DELETE' })
  },
}
